import { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfModality } from '../../database';
import api from '../../services/api';

export const useListModalitiesController = () => {
	const [modalitiesData, setModalitiesData] = useState<ModelOfModality[]>([]);
	const [selectedModality, setSelectedModality] = useState<ModelOfModality>();
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getModalities = () => {
		api.get('modalitys')
			.then(response => {
				setModalitiesData(response.data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeModality = (modality: ModelOfModality) => {
		setLoading(true);
		api.delete(`modalities/${modality.ID}`)
			.then(() => {
				getModalities();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A marca foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getModalities();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editModality = (Modality: ModelOfModality) => {
		setLoading(true);

		const editedModality: ModelOfModality = {
			...Modality,
		};

		api.put(`modalities/${selectedModality?.ID}`, editedModality)
			.then(() => {
				getModalities();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A marca foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getModalities();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getModalities();
	}, []);

	const openDeleteDialog = (Modality: ModelOfModality) => {
		setDeleteDialog(true);
		setSelectedModality(Modality);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (Modality: ModelOfModality) => {
		setEditDialog(true);
		setSelectedModality(Modality);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfModality>({
		initialValues: {
			DESCRICAO: '',
			TIPO: 0,
			PERCENTUALADITIVO: 0,
			PERCENTUALADITIVOOBRA: 0,
		},
		onSubmit: values => editModality(values),
		validationSchema,
	});

	return {
		getModalityListController: {
			formik,
			modalitiesData,
			selectedModality,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleModalityListController: {
			removeModality,
			editModality,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			getModalities,
		},
	};
};
